import hubless from 'hub-http/clients/noPortalApiClient';
import { resolveApi, hubletApi } from 'hub-http/middlewares/core';
import { stringify } from 'hub-http/helpers/params';
const API_BASE = 'userpreferences/v1/avatar';
export default class AvatarAPI {
  static getAvatarUrl(emailHash, query) {
    const queryString = stringify(query);
    return `https://${resolveApi(hubletApi('api', 'hubspot'))}/${API_BASE}/large/${emailHash}${queryString ? `?${queryString}` : ''}`;
  }
  static uploadAvatar({
    blob
  }) {
    return hubless.post(`${API_BASE}/upload`, {
      data: blob,
      headers: {
        'content-type': 'image/png'
      }
    });
  }
  static setGravatar() {
    return hubless.post(`${API_BASE}/gravatar`);
  }
  static removeAvatar() {
    return hubless.delete(API_BASE);
  }
}